import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import nissan from "../../../../assets/info/nissan-patrol/patrol-hero.jpg";
import castor from "../../../../assets/info/nissan-patrol/patrol-bushes_1.jpg";
import y60 from "../../../../assets/info/nissan-patrol/patrol-y60-drag-link.jpg";
import y61 from "../../../../assets/info/nissan-patrol/patrol-y61-drag-link.jpg";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { popularVehicle } from "../../../../vars/popularVehicles";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";

const NissanPatrol = () => {
  useSmallNav("Nissan Patrol");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Nissan Patrol"} bolder />
        <InfoHero image={nissan} />
        <InfoGrid>
          <div>
            <p>
              Kiedy pasjonaci off-road mówią o najlepszych pojazdach terenowych,
              dwa pojazdy są zwykle na szczycie listy pod względem niezawodności
              i możliwości podczas jazdy w terenie.
            </p>
            <InfoHeader text={"Nissan Patrol oraz Toyota Landcruiser"} />
            <p>
              Nissan Patrol istnieje na rynku od 1951 roku, prawie tak długo,
              jak marka Pedders! Uwielbiamy jego niezawodność i możliwości
              terenowe tego dużego auta 4x4. Są one jeszcze lepsze po
              zamontowaniu produktów Pedders Suspension, tworząc niesamowicie
              dzielny pojazd terenowy.
            </p>
            <p>
              Zawieszenie 4WD Trak Ryder jest efektem wielu lat rozwoju
              technicznego i zapewnia nowy poziom jazdy i komfortu właścicielom
              Nissana Patrola. Zawieszenia Pedders Trak Ryder to dziesiątki
              wysokiej jakości komponentów, z których każdy ma na celu poprawę
              jazdy.
            </p>
            <p>
              Istnieje wiele różnych wersji Patrola, począwszy od serii G60, MQ,
              MK, Y60 i Y61, w różnych rozstawach osi. Każdy Patrol ma
              indywidualny system zawieszenia, a my oferujemy wiele części do
              jego modernizacji, podnoszenia lub po prostu eksploatacji Patrola.
            </p>
            <InfoHeader text={"Jak wysoki będzie mój Patrol?"} />
            <p>
              Chociaż opisy zestawów podają przybliżone parametry, mogą one być
              trochę mylące. Jak wspomniano, sprężyny osiadają z czasem, więc
              2-calowe podwyższenie może okazać się nieco większe w
              rzeczywistości. Aby upewnić się, że dokładnie wiesz, co
              otrzymujesz, podajemy również dopasowaną wysokość. Mierzy się ją
              od dolnego rantu felgi do nadkola. Zaletą tej metody jest to, że
              wybór opon nie ma wpływu na podaną wysokość.
            </p>
            <p>
              Jeśli nadal nie jesteś pewien, czy mamy odpowiednie dla Ciebie
              części? Nie wiesz, który zestaw jest dla Ciebie odpowiedni?
              Skontaktuj się z nami lub wybranymi dystrybutorami, a odpowiedni
              specjaliści zadbają o to, byś otrzymał części dopasowane do Twoich
              potrzeb.
            </p>
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/rk_03CR8ySk"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/S9eT6vvfnSc"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Nissan")
              .models.find((e) => e.display === "Patrol")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <Gray>
              <InfoHeader
                size="smaller"
                text={"Podnosisz swojego Nissana Patrola?"}
              />
              <p>
                Zmieni się kąt pochylenia główki przedniego mostu napędowego.
              </p>
              <p>
                Prawidłowy kąt nachylenia utrzymuje samochód w linii prostej, a
                także powoduje samoczynne powracanie kierownicy do położenia
                neutralnego.
              </p>
              <p>
                Pedders oferuje gumową tuleję przedniego wahacza, która pozwala
                odzyskać prawidłowy kąt nachylenia na osi przedniej.
              </p>
              <p>
                Zalecamy, aby wszystkie podniesione Patrole Y60 i Y61 były
                wyposażone w tuleje korygujące Pedders 5802.
              </p>
              <div>
                <img src={castor} alt="Pedders Suspension 5802 Castor" />
              </div>
              <hr />
              <InfoHeader size="smaller" text={"Gumowe tuleje (4 sztuki)"} />
              <Button to={"/details/5802"}>Zobacz</Button>
            </Gray>
            <Gray>
              <InfoHeader
                size="smaller"
                text={"Regulowane drążki do Patrola"}
              />
              <p>Regulowany drążek do Patrola Y60</p>
              <PhotoLink style={{ marginBottom: "20px" }}>
                <img
                  src={y60}
                  alt="Regulowany drążek kierowniczy do Patrola Y60"
                />
                <Button to={"/details/PDL5001"}>Zobacz</Button>
              </PhotoLink>
              <p>Regulowany drążek do Patrola Y61</p>
              <PhotoLink>
                <img
                  src={y61}
                  alt="Regulowany drążek kierowniczy do Patrola Y61"
                />
                <Button to={"/details/PDL5002"}>Zobacz</Button>
              </PhotoLink>
            </Gray>
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Nissan" model="Patrol" /> */}
      </Container>
    </section>
  );
};

export default NissanPatrol;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;

const Button = styled(Link)`
  display: inline-block;
  text-transform: uppercase;
  color: white;
  background-color: var(--red);
  padding: 5px 10px;

  &:hover {
    color: white;
  }
`;

const PhotoLink = styled.div`
  display: flex;
  align-items: center;
  img {
    margin-right: 10px;
  }
`;
